import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {renderIf} from 'views/Shared'
import {ItemInformation} from "../../../AppLocals/Organization/OrganizationEntity";
import {Avatar} from "antd";
import {Link} from "react-router-dom";
import getAliasName from "../../../../helpers/getAliasName";
import getTitle from "../../../../helpers/getTitle";
import {DoubleValueItem} from "../../../AppLocals/CatholicHousehold/components/CatholicHouseholdComponents";
import {BsInfoCircleFill} from "react-icons/bs";
import {FaUserGraduate} from "react-icons/fa6";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {GoDotFill} from "react-icons/go";
import {renderIfElse} from "../../../Shared";
import getLabelOfGender from "../../../../helpers/getLabelOfGender";
import {formatDate} from "../../../../helpers/datetimeHelpers";

export const EnrollmentInfo = ({item, className}) => {

    const t = useTranslate()
    const {
        student,
        user,
        course,
        contact_email,
        contact_phone,
        date_of_birth,
        gender,
        fullname,
        patron_saint_name,
        registered_subjects = [],
    } = item ?? {}

    return (
        <div className="py-2 render-border-center flex flex-col gap-1">
            <div className="flex items-center gap-2">
                <Avatar
                    size={32}
                    src={student?.avatar || user?.avatar}
                    icon={<FaUserGraduate size={12} className="text-color-500"/>}
                    className="flex flex-center background-200"
                />
                <div className="space-x-1 text-sm leading-snug">
                    <span className="text-color-300 italic">
                        {t('user')}
                    </span>
                    <Link to={getLinkToDetail(item)}
                          className="no-underline font-bold text-color-000">
                        {renderIf(
                            student?.patron_saint_name,
                            <span className="mr-1 font-medium text-color-300 italic">
                                {getAliasName(student, 'patron_saint')}
                            </span>
                        )}
                        {getTitle(student) || getTitle(user)}
                    </Link>
                    <span className="text-color-300 italic lowercase">
                        {t('registered for the course')}
                    </span>
                    <Link to={getLinkToDetail(course)} className="font-semibold text-green-600 italic no-underline">
                        {getTitle(course)}
                    </Link>
                    <span className="text-color-300 italic lowercase">
                        {t('for student')}
                    </span>
                </div>
            </div>
            <div className="ml-2 md:ml-3 mt-1 flex flex-col gap-1">
                <div className="flex items-center gap-2">
                    <BsInfoCircleFill size={14} className="text-blue-300"/>
                    <span className="font-bold text-sm text-blue-600 uppercase tracking-wide">
                        {t('student information')}
                    </span>
                    <div className="flex-1 line-border-opacity text-blue-200"/>
                </div>
                <div className="ml-2 md:ml-3 flex flex-col gap-1">
                    <ItemInformation
                        primary={true}
                        showIcon={true}
                        label="full name"
                        value={`${patron_saint_name || ''} ${fullname}`}
                        className="text-sm"
                    />
                    <DoubleValueItem
                        showIcon={true}
                        labelFirst="date of birth"
                        valueFirst={formatDate(date_of_birth, 'DD/MM/YYYY')}
                        labelSecond={gender !== 0 ? ' - ' : ''}
                        valueSecond={t(getLabelOfGender(gender))}
                        className="text-xs italic"
                    />
                    <DoubleValueItem
                        showIcon={true}
                        labelFirst="contact"
                        valueFirst={contact_phone}
                        labelSecond={contact_email ? ' - ' : ''}
                        valueSecond={contact_email}
                        className="text-xs italic"
                    />
                    <div className="flex-1 space-x-1 text-xs">
                        <GoDotFill size={10} className="text-color-400"/>
                        <span className="text-color-500 whitespace-no-wrap italic">
                            {`${t('subjects registered')} :`}
                        </span>
                        {renderIfElse(
                            registered_subjects.length > 0,
                            registered_subjects.map((e, i) => (
                                <span key={i} className="font-semibold text-color-000">
                                    {getTitle(e)} {i < registered_subjects.length - 1 && ', '}
                                </span>
                            )),
                            <span className="font-semibold text-color-300">
                                {t('not update')}
                            </span>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
